class ConstTiposUsuario
{
  Administrativo = 1;
  Cliente = 2;
  Contacto = 3;
  ServicioCliente = 4;
  Ventas = 5;
  Transportista = 6;
  Logistica = 7;
  TransportistaOperator = 8;

  vals = {
    1: "administrative",
    2: "client",
    3: "contact",
    4: "customerService",
    5: "sales",
    6: "transportista",
    7: "logistic",
    8: "transportistaOperator"
  };
  constructor(obj = {}) {
    Object.assign(this, obj);
  }
  getValue(tipo){
    return this.vals[tipo];
  }
}

module.exports = ConstTiposUsuario;
